import { PayPublicServicesAutomaticService } from './../../../../services/payPublicServicesAutomatic/pay-public-services-automatic.service';
import { UtilsService } from './../../../../services/utils/utils.service';
import { UserService } from './../../../../services/user/user.service';
import {
  IProviderServices,
  PaymentServicesService,
} from './../../../../services/payment-services/payment-services.service';
import { AlertService } from './../../../../services/alert/alert.service';
import { LoaderService } from './../../../../services/loader/loader.service';
import { StorageService } from './../../../../services/storage/storage.service';
import { RemoteConfigService } from './../../../../services/remote-config/remote-config.service';
import { PopoverComponent } from './../../../../components/popover/popover.component';
import { ModalInstructionsDataConfig } from '../../../../components/modal-instructions/ModalsData/ModalInformationDataConfigPublicServices';
import { ModalInstructionsComponent } from './../../../../components/modal-instructions/modal-instructions.component';

import { LanguagesService } from './../../../../services/languagesService/languages.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  IPaymentServices,
  fieldsPayment,
} from '../../payment-services/IPayment-services.model';

import moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalInstructionsService } from './../../../../components/modal-instructions/modal-instructions.service';
import { CODES_ERROR } from './CODES_ERROR';
import { CanExchangeService } from './../../../../services/can-exchange/can-exchange.service';
import { KEY_LAST_PROVIDER_SELECTED } from '../pay-public-services-automatic.page';
import { TagsService } from 'src/app/services/tags/tags.service';

export interface Iprovider {
  name: string;
  image: string;
  categoryId: string;
  agreementId: number;
  agreementType: string;
  agreementName: string;
  bankName: string;
  reference1Description?: string;
  reference2Description?: string;
  sku_external?: string;
}
@Component({
  selector: 'app-form-pay-public-services-automatic',
  templateUrl: './form-pay-public-services-automatic.component.html',
  styleUrls: ['./form-pay-public-services-automatic.component.scss'],
})
export class FormPayPublicServicesAutomaticComponent implements OnInit {
  image = '';
  ModalInformation = ModalInstructionsComponent;
  modalData = ModalInstructionsDataConfig();

  totalbyUsyng;
  lastPriceUsed = 0;
  lastReference = '';

  CategoryId;

  buttonText = 'Continuar';
  IsRedemption = false;

  Providers: Iprovider[];

  PaymentData: IPaymentServices;
  imageProvider = '';
  dataProvider: IProviderServices[];
  points: any;

  fields: Array<fieldsPayment> = [];
  fieldsDefault: Array<fieldsPayment> = [];
  PaymentServicesForm: FormGroup;
  LOADER_ID = 'paymentServices-form';
  MinDate = moment().add(10, 'd').format('YYYY-MM-DD');
  loadingForm = false;

  dataOrder: {
    programId: any;
    companyId: any;
    uid: any;
    sku: any;
    quantity: number;
    appId: any;
    user: {
      username: any;
      name: any;
      lastname: any;
      docId: any;
      email: any;
      phone: any;
      docType: any;
    };
    puntoredRecaudo: { amount: any };
  };
  userinfo: { name: any; docId: any; lastname: any; docType: any } = {
    name: '',
    docId: '',
    lastname: '',
    docType: '',
  };
  checking = false;

  storeName = [];
  lastSelected;
  @ViewChild('storeInput') storeInput: ElementRef<HTMLInputElement>;
  constructor(
    public languageService: LanguagesService,
    private remoteConfig: RemoteConfigService,
    private formBuilder: FormBuilder,
    private storageServices: StorageService,
    private loaderService: LoaderService,
    private alertService: AlertService,
    private router: Router,
    private popoverController: PopoverController,
    private paymentService: PaymentServicesService,
    private userService: UserService,
    private utilsService: UtilsService,
    private payPublicServicesAutomaticService: PayPublicServicesAutomaticService,
    private routerActivated: ActivatedRoute,
    private modalInstructionsService: ModalInstructionsService,
    private canExchangeService: CanExchangeService,
    private tagsService: TagsService
  ) {
    this.PaymentServicesForm = this.formBuilder.group({});
  }
  async ngOnInit() {
    this.CategoryId = this.routerActivated.snapshot.paramMap.get('CategoryId');
    this.remoteConfig
      .getSettingPayServicesAutomaticConfig()
      .subscribe((data: IPaymentServices) => {
        this.PaymentData = data;
        // this.getPoints();
        this.image =
          data.banner ||
          'https://firebasestorage.googleapis.com/v0/b/gnx-mvp-improved-stg.appspot.com/o/Default%2FPublic%20Services%2Finstructions%2FbannerServicios.png?alt=media&token=3275aa6b-7d3d-4ebc-a567-a2961085a5f8';
      });
    this.generateForm();
    this.getUserInfo();
    // this.getStoreName();
  }

  async ionViewDidEnter() {
    this.CategoryId = this.routerActivated.snapshot.paramMap.get('CategoryId');
    this.PaymentServicesForm.reset();
    const provider = await this.storageServices.get(KEY_LAST_PROVIDER_SELECTED);
    if (provider) {
      this.routerActivated.queryParams.subscribe((params) => {
        console.log(params); // { orderby: "price" }

        if (params.selected_provider) {
          this.storeSelected(provider, this.storeInput);
        }
      });
    }
  }

  async getStoreName(event?) {
    var value = event.target.value;
    if (!value) this.storeName = [];
    // this.exhibitionForm.controls.storeName.setErrors({'incorrect': true})
    if (value.length <= 2) return;
    const filter = `categoryId:${this.CategoryId}`;
    const data: any = await this.payPublicServicesAutomaticService.getStoreName(
      value,
      filter,
      true
    );
    console.log('getStoreName', data);

    this.storeName = (data.hits as Array<any>).filter(
      (element) =>
        element.reference1Description.length ||
        element.reference2Description.length
    );
  }

  async setProviderImage($event) {
    if ($event instanceof Event) {
      const value = $event.target['value'];
      this.imageProvider = value.image;
      this.fields = [...this.fieldsDefault];

      this.setContinueInBotton();
      await this.addFieldsReference(value);
    } else if ($event) {
      console.log('enter else');

      const value = $event;
      this.imageProvider = value.image;
      this.fields = [...this.fieldsDefault];

      this.setContinueInBotton();
      await this.addFieldsReference(value);
    }
  }

  async addFieldsReference(value) {
    this.fields = [...this.fieldsDefault];
    if (Object.keys(this.f).includes('reference1Description')) {
      this.PaymentServicesForm.removeControl('reference1Description');
      this.PaymentServicesForm.updateValueAndValidity();
    }
    if (Object.keys(this.f).includes('reference2Description')) {
      this.PaymentServicesForm.removeControl('reference2Description');
      this.PaymentServicesForm.updateValueAndValidity();
    }
    if (value.reference1Description) {
      await this.PaymentServicesForm.addControl(
        'reference1Description',
        this.formBuilder.control('', [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9]*$'),
          Validators.minLength(3),
          Validators.maxLength(30),
        ]) //[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ ]
      );

      const field = {
        name: 'reference1Description',
        key: 'reference1Description',
        type: 'text',
        label: value.reference1Description,
        isRequired: true,
        hasHelp: true,
        valueHelp:
          'Contrato, Referencia de pago, Número para pago, Cédula del cliente, Número de cliente o Número de suministro.',
        labelProps: {
          color: 'dark',
        },
        validations: 'required',
      };

      this.fields = [...this.fields, field];
    }
    if (value.reference2Description) {
      await this.PaymentServicesForm.addControl(
        'reference2Description',
        this.formBuilder.control('', [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9]*$'),
          Validators.minLength(3),
          Validators.maxLength(30),
        ])
      );

      const field = {
        name: 'reference2Description',
        key: 'reference2Description',
        type: 'text',
        label: value.reference2Description,
        isRequired: true,
        hasHelp: true,
        valueHelp:
          'Contrato, Referencia de pago, Número para pago, Cédula del cliente, Número de cliente o Número de suministro.',
        labelProps: {
          color: 'dark',
        },
        validations: 'required',
      };

      this.fields = [...this.fields, field];
    }
    console.log('addFieldsReference ', this.f);
    this.PaymentServicesForm.updateValueAndValidity();
  }

  get f() {
    return this.PaymentServicesForm.controls;
  }

  async handlerButton() {
    console.log('handler Button', this.IsRedemption);
    if (this.IsRedemption) {
      this.sendForm();
    } else {
      await this.CheckAgreement();
    }
  }

  handlerBlur($_, field) {
    if (field.name == 'price') this.calculateValueService();
    if (field.name == 'reference1Description') {
      if (this.lastReference != $_.target.value) {
        this.setContinueInBotton();
        this.lastReference = $_.target.value;
      }
    }
  }
  setContinueInBotton() {
    this.totalbyUsyng = undefined;
    this.buttonText = 'Continuar';
    this.IsRedemption = false;
    const fields = [...this.fields];
    const indexPrice = fields.findIndex((element) => {
      return element.name == 'price';
    });
    if (indexPrice >= 0) {
      fields.splice(indexPrice, 1);
      this.fields = [...fields];
    }
    if (Object.keys(this.f).includes('price')) {
      this.PaymentServicesForm.removeControl('price');
      this.PaymentServicesForm.updateValueAndValidity();
    }
  }

  async CheckAgreement() {
    this.loadingForm = true;
    console.debug('CheckAgreement', this.checking);
    console.debug('CheckAgreement lastSelected', this.lastSelected);
    if (!this.checking) {
      this.checking = true;
      const value = this.lastSelected;
      const data = {
        amount: 1,
        agreementId: `${value.agreementId}`,
        reference1: this.f['reference1Description']?.value,
        reference2: this.f['reference2Description']?.value,
      };
      if (!data.reference1) delete data.reference1;
      if (!data.reference2) delete data.reference2;

      try {
        const check =
          await this.payPublicServicesAutomaticService.CheckAgreement(data);
        this.addFieldsPrice(check);
        this.buttonText = this.getTextsIUPagePaymentServices.btn_add;
        this.IsRedemption = true;
        this.loadingForm = false;
      } catch (error) {
        console.error('error check try', error);
        this.loadingForm = false;
        await this.ErrorHandler(error);
      } finally {
        this.checking = false;
        this.loadingForm = false;
      }
    }
  }

  async ErrorHandler(error) {
    if (error instanceof HttpErrorResponse) {
      if (error.status == 400) {
        if (Object.keys(CODES_ERROR).includes(error.error.code)) {
          console.clear();
          console.log(CODES_ERROR);
          console.log(`${[error.error.code]}`);
          console.log(`${CODES_ERROR[error.error.code].icon}`);
          const MODAL_INSTRUCCIONES_DATA = {
            icon: `${CODES_ERROR[error.error.code].icon}`,
            // title: remoteData?.title ? remoteData.title :'Sigue estos pasos para pagar con tus Pointz.',
            subtitle: `${CODES_ERROR[error.error.code].message}`,
            hasButtonDismiss: true,
            labelButtonDismiss: 'Regresar',
            buttons: [],
          };
          this.modalInstructionsService.OpenModal(
            MODAL_INSTRUCCIONES_DATA,
            '40vh'
          );
        } else {
          // this.alertService.presentAlert("Debes diligenciar los campos requeridos");
        }
      }
      if (error.status == 500) {
        this.alertService.presentAlert('error en consulta');
      }
    }
  }

  async addFieldsPrice(checkData) {
    if (checkData) {
      if (!Object.keys(this.f).includes('price')) {
        await this.PaymentServicesForm.addControl(
          'price',
          this.formBuilder.control('', {
            validators: [Validators.required],
            updateOn: 'blur',
          })
        );
        this.f['price'].setValue('');
      }

      const field = {
        name: 'price',
        key: 'price',
        type: 'number',
        label: 'Valor a Pagar',
        isPrice: true,
        isRequired: true,
      };
      console.debug(this.fields);
      const fields = [...this.fields];
      const indexPrice = fields.findIndex((element) => {
        return element.name == 'price';
      });
      if (indexPrice < 0) {
        this.fields = [...this.fields, field];
      }

      if (checkData.amount) {
        this.f['price'].setValue(checkData.amount);
        if (checkData.requiresAmount == 0) {
          this.f['price'].disable();
        }
        await this.calculateValueService();
      }
    }
  }

  async calculateValueService() {
    if (this.lastPriceUsed != this.f['price'].value) {
      this.lastPriceUsed = this.f['price'].value;
      this.totalbyUsyng = '...';
      this.loadingForm = true;
      if (this.f['price'].value && this.f['storeName'].value) {
        this.totalbyUsyng = '...';
        const price = `${this.f['price'].value}`
          .replace(/\./g, '')
          .replace(',', '.')
          .replace(/\./g, '');
        const data = {
          cost: parseInt(price),
          sku: `${this.lastSelected.objectID}`,
          /*  sku: `${this.lastSelected.agreementId}` */
        };
        try {
          const value: any =
            await this.payPublicServicesAutomaticService.CalculateValueServices(
              data
            );
          this.totalbyUsyng = value.valueInPoints;
          this.points = value.total;
          this.loadingForm = false;
          console.log('calculateValueService', value);
        } catch (error) {
          this.loadingForm = false;
          // this.totalbyUsyng = undefined;
          console.error('calculateValueService error', error);
          this.ErrorHandler(error);
        }
      }
    }
  }

  async generateForm() {
    const fieldsData = await this.remoteConfig
      .getSettingPayServicesAutomaticConfig()
      .toPromise();
    this.fields = fieldsData.fields;
    this.fieldsDefault = [...this.fields];
    let validations = [];
    this.fields.map(async (field) => {
      validations = [];
      field.validations?.includes('required')
        ? validations.push(Validators.required)
        : '';
      field.validations?.includes('min')
        ? validations.push(
            Validators.minLength(field.validations.split(':')[0])
          )
        : '';
      field.validations?.includes('max')
        ? validations.push(
            Validators.maxLength(field.validations.split(':')[0])
          )
        : '';

      if (field.type == 'number' && field.isPhone) {
        validations.push(Validators.pattern(/^[0-9]*$/));
      }

      await this.PaymentServicesForm.addControl(
        field.name,
        field.subfields
          ? this.formBuilder.array([], validations)
          : this.formBuilder.control('', validations)
      );
      // if (field.type == "select" && field.key == "id") {
      //   // this.Providers = await this.payPublicServicesAutomaticService.getProviders(this.CategoryId);
      //   console.log(this.Providers);

      //   // this.dataProvider = await this.paymentService.getProviders();
      //   if (this.Providers.length) {
      //     this.Providers.forEach((data) => {
      //       const provider = { label: data.name, value: data }
      //       field.options.push(provider)
      //     })
      //   }
      // }
    });
  }

  cancel() {
    this.PaymentServicesForm.reset();
    this.router.navigateByUrl('app/home');
  }
  getUserInfo() {
    this.userService.getUserInfo().subscribe(async (basicUserInfo: any) => {
      this.userinfo.name = basicUserInfo.name;
      this.userinfo.docId = basicUserInfo.gnxCredential1;
      this.userinfo.lastname = basicUserInfo.lastnames;
      this.userinfo.docType = basicUserInfo.docType;
    });
  }

  async sendForm() {
    console.log({ ...this.PaymentServicesForm });
    this.loadingForm = true;
    this.loaderService.presentLoading(this.LOADER_ID);

    if (this.totalbyUsyng && this.totalbyUsyng != '...') {
      /* if (true) { */
      if (this.PaymentServicesForm.valid) {
        try {
          const claims = await this.storageServices.get('gnx-claims');
          console.log(claims);
          await this.statusOrderhandler({ status: 'order_loading' });
          this.dataOrder = {
            programId: claims.programs[0].split('/')[3],
            companyId: claims.programs[0].split('/')[1],
            uid: claims.uid,
            sku: this.lastSelected.objectID, //this.f["id"].value,
            quantity: 1,
            appId: claims.app_id,
            user: {
              username: claims.username,
              name: this.userinfo.name,
              lastname: this.userinfo.lastname,
              docId: this.userinfo.docId,
              email: claims.email,
              phone: claims.phone,
              docType: this.userinfo.docType,
            },
            puntoredRecaudo: {
              amount: Number(
                this.f['price'].value.replaceAll('.', '').replaceAll(',', '')
              ),
            },
          };

          this.paymentService
            .savepaymentServices({ ...this.dataOrder })
            .then(async (data: any) => {
              console.log(data);
              if (
                data.code === 'NOT_FOUND' ||
                data.code === 'INSUFFICIENT_POINTS'
              ) {
                this.statusOrderhandler({
                  status: 'order_error',
                  ...this.dataOrder,
                  response: data,
                });
              } else if (data.code === 'created') {
                this.PaymentServicesForm.reset();
                this.statusOrderhandler({
                  status: 'order_success',
                  ...this.dataOrder,
                  response: data,
                });
                this.router.navigate([
                  'app',
                  'payment-services',
                  'requestReceived',
                  data.id,
                  'OK',
                ]);
                this.loadingForm = false;
              } else {
                this.statusOrderhandler({
                  status: 'order_error',
                  ...this.dataOrder,
                  response: data,
                });
              }
              this.loadingForm = false;
              this.PaymentServicesForm.reset();
              await this.loaderService.cancelLoader(this.LOADER_ID);
            })
            .catch((error) => {
              console.log('catch((error', error);
              this.loaderService.cancelLoader(this.LOADER_ID);
              this.loadingForm = false;
              if (error.code === 'USER_LOCKED') {
                this.canExchangeService.openModal();
              } else {
                this.statusOrderhandler({
                  status: 'order_error',
                  ...this.dataOrder,
                  response: error,
                });
              }
            })
            .finally(() => {
              this.tagsService.setTagFromEvent(
                'bill_paymen_automatic_redemption'
              );
            });

          this.loaderService.cancelLoader(this.LOADER_ID);
        } catch (error) {
          await this.loaderService.cancelLoader(this.LOADER_ID);
          this.alertService.showErrorAlert(`Error, ${error}`);
        }
      } else {
        this.loaderService.cancelLoader(this.LOADER_ID);
        this.alertService.presentAlert(
          'Debes diligenciar los campos requeridos'
        );
      }
    } else {
      this.loadingForm = false;
      this.loaderService.cancelLoader(this.LOADER_ID);
      this.alertService.presentAlert(
        'Intente una vez se haya realizado el calculo de los Pointz'
      );
    }
  }

  async statusOrderhandler(orderStatus) {
    console.log('orderStatus', orderStatus);
    const codes = {
      order_success: 'Tu Orden fue creada correctamente',
      order_loading: 'Estamos creando tu orden',
    };

    if (codes[orderStatus.status]) {
      this.alertService.presentAlert(codes[orderStatus.status]);
      setTimeout(() => {
        this.alertService.alertController.dismiss();
      }, 2000);
    }

    if (orderStatus.status === 'order_error') {
      const codesError = {
        NOT_FOUND: 'El producto no se encuentra disponible actualmente',
        INSUFFICIENT_POINTS: 'No tienes coins suficientes',
        VALIDATION_STOCK_ERROR: 'Stock Insuficiente',
        PRODUCT_DISABLED: 'El producto no se encuentra disponible actualmente',
      };

      if (codesError[orderStatus.response.code]) {
        this.alertService.presentAlert(codesError[orderStatus.response.code]);
      } else if (orderStatus.error) {
        this.alertService.presentAlert(orderStatus.error);
      } else {
        var errorText = orderStatus?.error ? orderStatus?.error : '';
        this.alertService.presentAlert(
          `Ups, Tenemos problemas para crear tu orden. No hay bono disponible - ${errorText}`
        );
      }
      setTimeout(() => {
        return this.alertService.alertController.dismiss();
      }, 2000);
    }
  }

  async presentPopover(ev: any, field) {
    console.log(field.valueHelp);

    const popover = await this.popoverController.create({
      component: PopoverComponent,
      event: ev,
      translucent: true,
      componentProps: {
        message: field.valueHelp,
      },
    });
    return await popover.present();
  }
  get getTextsIUPagePaymentServices() {
    return this.languageService.textsIU.page_payment_services;
  }

  keyPressNumber($event) {
    return this.utilsService.keyPressNumber($event);
  }

  storeSelected(store, input) {
    this.storeName = [];
    console.log(input);
    // this.exhibitionForm.controls.storeName.setErrors(null)
    if (input instanceof ElementRef) {
      console.log('is input HTMLInputElement', store);
    } else {
      input.value = store.agreementName;
    }
    this.lastSelected = store;
    this.f.storeName.setValue(store.agreementName);
    this.f.storeName.disable();
    this.setProviderImage(store);
  }

  clear(input) {
    input.value = '';
    this.f.storeName.enable();
    this.addFieldsReference({});
    //this.exhibitionForm.controls.storeName.setErrors({'incorrect': true})
  }

  setTag(tag) {
    this.tagsService.setTagFromEvent(tag);
  }
}
